import { api } from '@/core/api/';

const URL = 'api/contracteditor';

export const getInitFilters = () => api.get(`${URL}/initfilters`);

export const search = (payload) =>
  api.get(`${URL}/search`, {
    params: {
      ...payload,
    },
  });

export const saveContractEditor = (payload) =>
  api.post(`${URL}/savecontracteditor`, payload);

export const getContractEditor = (academicYearId, contractTypeId, versionId) =>
  api.get(
    `${URL}/contracteditor/${academicYearId}/${contractTypeId}${
      versionId != null ? `/${versionId}` : ''
    }`
  );

export const getContractEditorPreview = (payload) =>
  api.post(`${URL}/preview`, payload);

export const getContractEditorTokens = () =>
  api.get(`${URL}/contracteditortokens`);

export const checkForExistingContractEditor = (
  academicYearId,
  contractTypeId
) =>
  api.get(
    `${URL}/checkforexistingcontracteditor/${academicYearId}/${contractTypeId}`
  );

export const discardDraftVersion = (payload) =>
  api.delete(`${URL}/discarddraftversion`, {
    params: {
      ...payload,
    },
  });

export const createNewVersion = (payload) =>
  api.post(`${URL}/createnewversion`, payload);

export const publishVersion = (payload) =>
  api.post(`${URL}/publishversion`, payload);
